import React from 'react'
import { useLocation } from 'react-router-dom'
import useFeatureFlags from 'hooks/useFeatureFlags'
import MedicationInformationScreenV2 from './MedicationInformationScreenV2'
import ResidentMedScreen from '../../ResidentEmarScreens/ResidentMedScreen/ResidentMedScreen'

const MedicationInformationScreenV2Wrapper: React.FC = () => {
  const flags = useFeatureFlags({ flagNames: ['emar_v2_chart'] })?.data
  const location = useLocation()

  const emarV2ChartEnabled = flags?.emar_v2_chart?.enabled ?? false

  const isNestedRoute =
    location.pathname.includes('/edit') ||
    location.pathname.includes('/chart') ||
    location.pathname.includes('/details')

  if (emarV2ChartEnabled && !isNestedRoute) {
    return <MedicationInformationScreenV2 />
  }

  return <ResidentMedScreen />
}

export default MedicationInformationScreenV2Wrapper
